module.exports = __webpack_public_path__ + "static/media/home-ana-awards.b5c9c241.webp";